import { BASE_URL } from "../constants/constants";
import { ACCESS_TOKEN_CHANGED_EVENT, getAccesToken } from "../Localstorage/localstorage";
import { buildSocketClientOptions, getSocketBaseUrl } from "./socketConfig";


const { io } = require("socket.io-client");

function currentAccessToken() {
  try {
    return getAccesToken() || "";
  } catch (error) {
    return "";
  }
}

export const IOSOCKETCLIENT = io(
  getSocketBaseUrl({ baseUrl: BASE_URL }),
  buildSocketClientOptions({ token: currentAccessToken() })
);

export const refreshIOSocketAuth = () => {
  const token = currentAccessToken();
  IOSOCKETCLIENT.auth = { ...(IOSOCKETCLIENT.auth || {}), token };
  return token;
};

export const ensureIOSocketConnected = () => {
  const token = refreshIOSocketAuth();
  if (!token) {
    IOSOCKETCLIENT.disconnect();
    return false;
  }

  if (!IOSOCKETCLIENT.connected) {
    IOSOCKETCLIENT.connect();
  }

  return true;
};

if (typeof window !== "undefined") {
  window.addEventListener(ACCESS_TOKEN_CHANGED_EVENT, () => {
    if (refreshIOSocketAuth()) {
      ensureIOSocketConnected();
    } else {
      IOSOCKETCLIENT.disconnect();
    }
  });
}

// Add comprehensive error handling and logging
IOSOCKETCLIENT.on('connect_error', (error) => {
  console.warn('Socket.IO connection error:', error?.message || error);
});

IOSOCKETCLIENT.on('connect', () => {
  const transport = IOSOCKETCLIENT.io.engine.transport.name;
  console.log(`Socket.IO connected successfully via ${transport}`);
});

IOSOCKETCLIENT.on('disconnect', (reason) => {
  // Only log unexpected disconnections
  if (reason !== 'io client disconnect') {
    console.log('Socket.IO disconnected:', reason);
  }
});

export const emitSocketRoomChange = (action, channel) => {
  if (!channel) return;
  IOSOCKETCLIENT.emit('JOINLEAVEROOM', { action, channel }, (ack) => {
    if (ack?.ok === false) {
      console.warn(`Socket.IO room ${action} rejected:`, {
        channel,
        reason: ack.reason,
      });
    }
  });
};

export const setIOSocketListeners = (channel, socket_channel, listenerCallBacks) => {
  if (channel) {
      if (!ensureIOSocketConnected()) return undefined;

      emitSocketRoomChange('join', channel);

      const handler = (data) => {
          console.log('Received data on channel:', data); // Debugging line
          listenerCallBacks(data); // Call the listener callback
      };

      IOSOCKETCLIENT.on(socket_channel, handler);

      return () => {
        IOSOCKETCLIENT.off(socket_channel, handler);
        emitSocketRoomChange('leave', channel);
      };
  }

  return undefined;
}
